<template>
    <NuxtLayout>
        <div class="body-block">
            <div class="title-container">
                <div class="container-xl">
                    <div class="doc-title-container">
                        <div class="row">
                            <div class="col-sm-12 col-lg-6">
                                <h1 class="page_title mt-10">Согласие на получение информационных сообщений</h1>
                            </div>
                            <div class="col-lg-6 d-none d-lg-block text-end">
                                <img src="/images/documents/document_view.png" alt="" class="doc-image"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body-documents">
                <div class="container-xl">
                    <p>Согласие на получение информационных сообщений рекламного характера</p>
                    <p>Настоящим, в соответствии с законом Республики Казахстан от 19 декабря 2003 года «О рекламе» и
                        Правил оказания услуг сотовой связи (Приложение 2 к Приказу исполняющего обязанности Министра по
                        инвестициям и развитию Республики Казахстан от 24 февраля 2015 года № 171) свободно, своей волей
                        и в своем интересе выражаю свое согласие ТОО «ПЭК Казахстан», БИН 121140009856, юр. адрес:
                        050050, Казахстан, г. Алматы, Жетысуский район, ул. Казыбаева, д. 3 на получение
                        рекламно-информационных материалов об услугах, мероприятиях, акциях, специальных предложениях и
                        иных сообщений связанных с услугами реализуемыми ТОО «ПЭК Казахстан» и/или его партнеров.</p>
                    <p>Настоящее согласие распространяется на получение сообщений рекламного и информационного характера
                        посредством беспроводных и проводных телекоммуникационных линий (рассылки по электронной почте,
                        голосовые и текстовые сообщения), а также информационно-телекоммуникационной сети "Интернет"
                        (таргетированная реклама, реклама в социальных сетях, мессенджерах «WhatsApp» и «Telegram»).</p>
                    <p>Настоящее согласие действует бессрочно с момента его предоставления.</p>
                    <p>Я осведомлен о возможности в любое время отказаться от получения сообщений
                        рекламно-информационного характера путем направления отзыва согласия на электронную почту ТОО
                        «ПЭК Казахстан» pnd@pecom.ru.</p>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script>
export default {
    name: "index"
}
</script>

<style scoped>

</style>
